<div class="declaration-container">

<h6>Choose Listing Type for Property Marketing</h6>

<!-- FREE -->
<div class="form-check mb-3">

    <input
        class="form-check-input"
        type="radio"
        name="listing"
        id="free"
        value="free"
        [checked]="isFreeSelected"
        [disabled]="optionsDisabled"
        (change)="onListingOptionChange('free')">

    <label class="form-check-label" for="free">

        <strong>FREE LISTING</strong>

        <div class="listing-description">
            For Project Marketing (OTP)
        </div>

    </label>

</div>

<!-- PREMIUM -->
<div class="form-check mb-3">
    <input class="form-check-input"
           type="radio"
           name="listing"
           id="premium"
           value="premium"
           [disabled]="optionsDisabled"
           (change)="onListingOptionChange('premium')">

   <label class="form-check-label" for="premium">

    <strong>PREMIUM LISTING</strong>

    <div class="listing-description">
        For Project Marketing & Sales - Agreed Commission (OTP)
    </div>

</label>
</div>

<!-- COMMISSION -->
<div *ngIf="isPremiumSelected" class="ml-4 mb-3">

    <label>Agreed Commission (%)</label>

    <input type="number"
           class="form-control"
           [ngModel]="commissionPercentage"
           (ngModelChange)="onCommissionChange($event)"
           [ngModelOptions]="{standalone:true}"
           min="1"
           max="100">

</div>

<!-- NEXUS -->
<div class="form-check mb-3">

    <input
    class="form-check-input"
    type="checkbox"
    id="nexus"
   [disabled]="
    optionsDisabled ||
    !isPremiumSelected ||
    !commissionPercentage ||
    commissionPercentage <= 0
"
    (change)="onNexusChange($event)">

    <label class="form-check-label" for="nexus">
        <strong>NEXUS NETWORK</strong>
         <div class="listing-description">
            Reach out to Agents Community
        </div>
    </label>

</div>

<!-- YES / NO -->
<div *ngIf="isNexusSelected" class="ml-4 mb-3">

    <label class="form-label">
        Enable Nexus Network?
    </label>

    <div class="form-check">

      <input
    class="form-check-input"
    type="radio"
    name="nexusConsent"
    value="yes"
    [disabled]="optionsDisabled"
    (change)="onNexusConsentChange('yes')">
        <label class="form-check-label">
            Yes
        </label>

    </div>

    <div class="form-check">
<input
    class="form-check-input"
    type="radio"
    name="nexusConsent"
    value="no"
    [disabled]="optionsDisabled"
    (change)="onNexusConsentChange('no')">

        <label class="form-check-label">
            No
        </label>

    </div>
    <!-- OTP VERIFICATION SECTION -->


</div>
<!-- OTP VERIFICATION SECTION -->

<div *ngIf="showOtpSection" class="verification-section">

    <h6>Verification</h6>

    <label>Mobile Number</label>

    <input
        type="text"
        class="form-control"
        maxlength="10"
        [(ngModel)]="mobileNumber"
        [ngModelOptions]="{standalone:true}"
        (keypress)="onlyNumbers($event)">

    <br>

    <button
        type="button"
        class="btn btn-primary mr-2"
        [disabled]="!isValidMobile(mobileNumber) || otpSent"
        (click)="sendOtp()">
        Generate OTP
    </button>

    <button
        type="button"
        class="btn btn-secondary"
        [disabled]="!otpSent"
        (click)="sendOtp()">
        Resend OTP
    </button>

    <br><br>

    <div *ngIf="otpSent">

  <div *ngIf="otpSent">

    <br><br>

    <label>Enter OTP</label>

    <input
        type="text"
        class="form-control"
        maxlength="6"
        [(ngModel)]="otpCode"
        [ngModelOptions]="{standalone:true}"
        (keypress)="onlyNumbers($event)">

    <br>

    <button
        type="button"
        class="btn btn-success"
        [disabled]="!isValidOtp(otpCode)"
        (click)="verifyOtp()">
        Verify OTP
    </button>

</div>
</div>
</div>